import React, { useContext } from 'react';
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  TextField,
  Select as MuiSelect,
  MenuItem
} from '@material-ui/core';
import styled from 'styled-components/macro';
import Animation from '../../../components/Animation';
import { TextString } from '../../../components/Text';
import GeneralContext from '../../GeneralContext';
import { DatePicker } from '../../../components/form/DateField';
import Input from '@material-ui/core/Input';

const NumberInput = styled(TextField)`
  text-align: center;
  vertical-align: middle !important;
  width: 4rem;
  & input {
    font-size: 16px;
    height: 1rem;
    text-align: center;
  }
`;

const Select = styled(MuiSelect)`
  font-size: inherit !important;
  margin: 0 0.5rem !important;
  max-width: 14rem;
  vertical-align: bottom !important;
  line-height: 16px;
`;

const SelectNoMaxWidth = styled(MuiSelect)`
  font-size: inherit !important;
  margin: 0 0.5rem !important;
  vertical-align: bottom !important;
  line-height: 16px;
`;

const DatePickerInput = styled(Input)`
  && {
    font-size: 16px;
    width: 6em;
  }
`;

const InlineAnimation = styled(Animation)`
  && {
    display: inline-block;
    vertical-align: bottom !important;
  }
`;

const RecurringView = props => {
  const api = useContext(GeneralContext);
  const { reminderData, update } = props;
  return (
    <>
      <FormGroup aria-label="recurring" row>
        <FormControlLabel
          control={
            <Checkbox
              checked={reminderData.recurrence}
              size="small"
              color="primary"
              onChange={props.toggleRecurring}
            />
          }
          label={<TextString content="form-builder.reminders.recurring" />}
          labelPlacement="end"
        />
      </FormGroup>
      <Animation type="collapse" in={reminderData.recurrence}>
        Repeats every
        <NumberInput
          data-testid={'recurring-interval-' + reminderData.id}
          onChange={e => {
            let newValue = parseInt(e.target.value);
            // interval number can't be lower than 1
            if (newValue < 1) {
              newValue = 1;
            }
            props.setIntervalCount(newValue);
          }}
          type="number"
          onBlur={() => update({ 'recurrence.interval': props.intervalCount })}
          value={props.intervalCount}
        />
        <Select
          data-testid={'interval-unit-' + reminderData.id}
          onChange={e => update({ 'recurrence.intervalUnit': e.target.value })}
          value={
            reminderData.recurrence
              ? reminderData.recurrence.intervalUnit
              : null
          }
        >
          <MenuItem
            value="day"
            data-testid={'recurring-interval-unit-' + reminderData.id + '-day'}
          >
            <TextString
              content="form-builder.reminders.days"
              values={{ count: props.intervalCount }}
            />
          </MenuItem>
          <MenuItem
            value="week"
            data-testid={'recurring-interval-unit-' + reminderData.id + '-week'}
          >
            <TextString
              content="form-builder.reminders.weeks"
              values={{ count: props.intervalCount }}
            />
          </MenuItem>
          <MenuItem
            value="month"
            data-testid={
              'recurring-interval-unit-' + reminderData.id + '-month'
            }
          >
            <TextString
              content="form-builder.reminders.months"
              values={{ count: props.intervalCount }}
            />
          </MenuItem>
        </Select>
        until
        <SelectNoMaxWidth
          data-testid={'recurring-stop-condition-' + reminderData.id}
          onChange={e => props.setStopCondition(e.target.value)}
          value={props.stopCondition}
        >
          {props.statusOptions.map(option => (
            <MenuItem
              key={'recurringstop-condition-' + option + reminderData.id}
              value={option}
              data-testid={
                'recurring-stop-condition-' + reminderData.id + '-' + option
              }
            >
              <TextString content={'form-builder.reminders.' + option} />
            </MenuItem>
          ))}
        </SelectNoMaxWidth>
        <InlineAnimation
          in={
            props.stopCondition === 'specific' ||
            props.stopCondition === 'field'
          }
        >
          {props.stopCondition === 'specific' ? (
            <DatePicker
              minDate={new Date()}
              placeholderText="Select date"
              value={props.selectedDate}
              onChange={dateValue => {
                props.setSelectedDate(dateValue);
              }}
              customInput={
                <DatePickerInput
                  id={'recurring-date-picker-' + reminderData.id}
                  aria-describedby="recurring-date-picker"
                />
              }
              data-testid={'date-picker-' + reminderData.id}
              minwidth="0"
            />
          ) : props.stopCondition === 'field' ? (
            <Select
              data-testid={'recurring-stop-condition-field' + reminderData.id}
              onChange={e => props.setSelectedField(e.target.value)}
              value={props.selectedField}
            >
              {api.allDateFields.map(option => (
                <MenuItem
                  key={
                    'recurringstop-condition-field' +
                    option.title +
                    reminderData.id
                  }
                  value={option.internalId}
                  data-testid={
                    'recurring-stop-condition-field' +
                    reminderData.id +
                    '-' +
                    option.title
                  }
                >
                  {option.title}
                </MenuItem>
              ))}
            </Select>
          ) : null}
        </InlineAnimation>
      </Animation>
    </>
  );
};

export default RecurringView;
